export class ChangeControlTransactionLabels {
    header:string;
    userName: string;
    status: string;
    date: string;
    constructor(header:string,userName: string, status: string, date: string) {
      this.header = header;
      this.userName = userName;
      this.status = status;
      this.date = date;
    }
  }
  